<template>
  <div class="main">
    <head-top/>
    <!-- 面包屑 -->
    <div class="container">
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/index' }">{{ $t('navbar.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path:  '/exhibition'}">{{ $t('navbar.exhibition') }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{name: 'exhibition_det',params: {id:newsForm.hzexhibitorId},}">{{ exName }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ newsForm.newsTitle }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content">
        <div class="title">
          {{ newsForm.newsTitle }}
        </div>

        <div class="date">
          {{newsForm.createDate}}
        </div>

        <div class="strip">
          <div class="strip_blue"></div>
        </div>

        <div class="article">
          <div v-html="newsForm.content"></div>
        </div>

        <div class="strip">
        </div>
      </div>

      <div class="others">
        <div v-if="newsForm.frontId">
          <span style="margin-right: 20px">{{ $t('exhibition.lastPage') }}</span> <span class="go" @click="goLast">{{newsForm.frontName}}</span>
        </div>
        <div style="margin-top: 19px" v-if="newsForm.backId">
          <span style="margin-right: 20px">{{ $t('exhibition.nextPage') }}</span> <span class="go" @click="goNext">{{newsForm.backName}}</span>
        </div>
      </div>
    </div>
    <foot-bottom/>
  </div>
</template>

<script>
import headTop from "../../common/head.vue";
import footBottom from "../../common/footBottom.vue";
import {getNewsDetail,getexhibit } from"../../../api/exhibitor";

export default {
  name: 'news_detail',
  data() {
    return {
      exName: '山西天巨重工机械有限公司',
      title: '第十九届中国国际煤炭采矿技术交流及设备展览会——招展工作火爆进行中',
      nextNews: '公司产品连续亮相鄂尔多斯和太原煤展会',
      lastNews: '热烈祝贺煤机公司崔奇峰获“晋城工匠”提名奖',
      id:this.$route.params.userId,
      newsForm:{},
    };
  },

  components: {
    headTop,
    footBottom,
  },
  created(){
    this.getNews()
  },
  computed: {},
  methods: {
    async getNews(){
      console.log(this.id);
      const data = await getNewsDetail({id:this.id})
      this.newsForm = data.data.data
      console.log(this.newsForm);
      const prams = await getexhibit({id:this.newsForm.hzexhibitorId})
      this.exName = prams.data.data.companyNameC
      console.log(this.exName);
    },
    // async getexhi(){
    //   const prams = await getNewsDetail({id:this.newsForm.hzexhibitorId})
    //   console.log(prams);
    // },
    goLast() {
      console.log('上一篇');
      this.id = this.newsForm.frontId;
      this.getNews();
    },
    goNext() {
      console.log('下一篇');
      this.id = this.newsForm.backId;
      this.getNews();
    }
  },
};
</script>
<style lang='scss' scoped>
* {
  font-family: Microsoft YaHei;
}

.main {
  margin-top: 120px;
  width: 100%;
  position: relative;
  .foot[data-v-f73ab1d2]{
    height: 246px;
    background-image: url(/img/backImg.98b0a33a.png);
    background-position: center;
    width: 100%;
    padding-bottom: 50px;
    background-size: cover;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
  }
  .container {
    width: 1270px;
    margin: 0 auto;
    //border: #b80059 1px solid;
    box-sizing: border-box;


    .content {
      //border: #fdd72a 1px solid;
      //height: 500px;
      width: 100%;
      margin-top: 70px;

      .title {
        font-size: 30px;
        text-align: center;
        //font-weight: 400;
        //box-sizing: border-box;
      }

      .date {
        color: #999999;
        font-size: 14px;
        text-align: center;
        margin: 19px 0 34px;
      }

      .strip {
        width: 100%;
        height: 4px;
        background: #E5F0F8;
        margin-bottom: 26px;
        //position: relative;
        .strip_blue {
          background: #006FB8;
          height: 100%;
          width: 245px;
        }
      }

      .article {
        width: 100%;
        line-height: 150%;
        margin-bottom: 47px;
        p {
          margin: 36px 0;
          font-size: 18px;
          color: #333333;
          text-indent:2em
        }

        img {
          width: 800px;
          height: 450px;
          display: block;
          margin:10px auto 0;
        }

        .subtitle {
          font-size: 24px;
          margin: 18px 0;
          color: #333333;
        }
      }

    }

    .others {
      width:  100%;
      height: 120px;
      color: #666666;
      font-size: 16px;

      .go:hover{
        cursor:pointer;
        color: #006FB8;
      }
    }
  }
}

</style>

<style scoped>
.el-breadcrumb__item >>> .el-breadcrumb__inner {
  font-weight: 500;
}

.el-breadcrumb__item:last-child >>> .el-breadcrumb__inner {
  color: #006FB8;
  font-weight: 500;
}

</style>

<style>

</style>
